import axios from 'axios'

const state = {
  item: {},
  ready: false
}

// getters
const getters = {
  account: (state) => state.item,
  admins: (state) => state.item.admins,
  sites: (state) => {
    if (state.item) {
      return state.item.sites
    } else {
      return null
    }
  },
  currentSite: (state) => {
    if (state.item && state.item.sites) {
      return state.item.sites.find(item => (item.sitekey === window['vm'].$route.params.site))
    } else {
      return null
    }
  },
  currentSitekey: (state) => {
    if (state.item && state.item.sites) {
      return state.item.sites.find(item => (item.sitekey === window['vm'].$route.params.site)).sitekey
    } else {
      return null
    }
  },
  sitekeys: (state) => {
    let sitekeys = []
    if (state.items && state.item.sites) {
      state.item.sites.forEach((site) => {
        sitekeys.push(site.sitekey)
      })
    }
    return sitekeys
  },

  defaultLang: (state) => {
    if (state.item && state.item.sites && state.item.sites[0] && state.item.sites[0].languages && window['vm'].$route.params.site) {
      return state.item.sites.find(item => (item.sitekey === window['vm'].$route.params.site)).languages.find(item => (item.default === 1)).lang
    } else {
      return 'en'
    }
  }
}

// actions
const actions = {
  LOAD_ACCOUNT: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      axios.get(process.env.API + '/account/')
        .then((response) => {
          commit('SET_ACCOUNT', { item: response.data })
          resolve(response.data)
        }, (e) => {
          reject(e)
        })
    })
  },
  addSite: ({ commit }, site) => {
    return new Promise((resolve, reject) => {
      axios.post(process.env.API + '/account/' + state.item.id + '/site/', site)
        .then(response => {
          commit('ADD_SITE', { item: response.data })
          resolve(response.data)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  updateSite: ({ commit }, site) => {
    return new Promise((resolve, reject) => {
      axios.put(process.env.API + '/account/site/' + site.id + '/', site)
        .then(response => {
          commit('SET_SITE', { item: response.data })
          resolve(response.data)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  postIPTrust: ({ commit, dispatch }, {site, ip}) => {
    return new Promise((resolve, reject) => {
      axios.post(process.env.API + '/account/site/' + site.id + '/ip/', [ip])
        .then((response) => {
          commit('SET_SITE', { site: site, item: response.data })
          resolve(response.data)
        }, (e) => {
          reject(e)
        })
    })
  },
  deleteIPTrust: ({ commit, dispatch }, {site, ip}) => {
    return new Promise((resolve, reject) => {
      axios.delete(process.env.API + '/account/site/' + site.id + '/ip/' + ip + '/')
        .then((response) => {
          commit('SET_SITE', { site: site, item: response.data })
          resolve(response.data)
        }, (e) => {
          reject(e)
        })
    })
  },

  addManager: ({ commit }, { user }) => {
    return new Promise((resolve, reject) => {
      axios.put(process.env.API + '/account/' + state.item.id + '/', {admins: [{user: user, accountmanager: 5}]})
        .then((response) => {
          commit('SET_ACCOUNT', { item: response.data })
          resolve(response.data)
        }, (e) => {
          reject(e)
        })
    })
  },

  deleteManager: ({ commit }, { user }) => {
    return new Promise((resolve, reject) => {
      axios.delete(process.env.API + '/account/' + state.item.id + '/admin/' + user.id + '/')
        .then((response) => {
          commit('SET_ACCOUNT', { item: response.data })
          resolve(response.data)
        }, (e) => {
          reject(e)
        })
    })
  },

  updateStatus: ({ commit }, { site, status }) => {
    return new Promise((resolve, reject) => {
      axios.put(process.env.API + '/account/site/' + site.id + '/status/', {status: status})
        .then((response) => {
          commit('SET_ACCOUNT', { item: response.data })
          resolve(response.data)
        }, (e) => {
          reject(e)
        })
    })
  },
  addLang: ({ commit }, { site, languages }) => {
    return new Promise((resolve, reject) => {
      axios.post(process.env.API + '/account/site/' + site.id + '/language/', languages)
        .then((response) => {
          commit('SET_SITE', { site: site, item: response.data })
          resolve(response.data)
        }, (e) => {
          reject(e)
        })
    })
  },
  updateLang: ({ commit }, { site, languages }) => {
    return new Promise((resolve, reject) => {
      axios.put(process.env.API + '/account/site/' + site.id + '/language/' + languages.lang + '/', languages)
        .then((response) => {
          commit('SET_SITE', { site: site, item: response.data })
          resolve(response.data)
        }, (e) => {
          reject(e)
        })
    })
  },
  removeLang: ({ commit }, { site, languages }) => {
    return new Promise((resolve, reject) => {
      axios.delete(process.env.API + '/account/site/' + site.id + '/language/' + languages.lang + '/', languages)
        .then((response) => {
          commit('SET_SITE', { site: site, item: response.data })
          resolve(response.data)
        }, (e) => {
          reject(e)
        })
    })
  },

  resetAccount ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_ACCOUNT')
      resolve()
    })
  }
}

// mutations
const mutations = {

  SET_ACCOUNT: (state, {
    item
  }) => {
    state.item = item
  },
  ADD_SITE: (state, { item }) => {
    state.item.sites.push(item)
  },
  SET_SITE: (state, { item }) => {
    state.item.sites.forEach((site) => {
      if (site.sitekey === item.sitekey) {
        Object.assign(site, item)
      }
    })
  },
  RESET_ACCOUNT: (state) => {
    state.item = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js